import { Component, OnInit, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { State } from '../reducer';

import { TealiumUtagService } from '../tealium/utag.service';

import * as menu from '../actions/menu';
import { RouterLinkActive } from '@angular/router';
import { MenuComponent } from './menu';
import { Angulartics2OnModule } from 'angulartics2';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'stars-header',
  templateUrl: './header.html',
  styleUrls: ['./header.scss'],
  imports: [RouterLinkActive, MenuComponent, Angulartics2OnModule, AsyncPipe]
})
export class HeaderComponent implements OnInit {
  private store = inject<Store<State>>(Store);
  private tealium = inject(TealiumUtagService);

  menuOpen$;

  ngOnInit(): void {
    this.menuOpen$ = this.store.select((s) => s.menu);
  }

  onToggleMenu() {
    this.store.dispatch(new menu.ToggleAction());
    const mobileMenuButton = document.getElementById('mobile-menu-button');
    if (this.menuOpen$) {
      mobileMenuButton.classList.toggle('close');
    }
  }

  tealiumLink(event: Event): void {
    this.tealium.link({
      tealium_event: 'outbound_clicks'
    });
  }
}
